export const SWIPER_DURATION = 2000;
export const SWIPER_DELAY = 8000;

export const SIDE_SWIPER_SLIDES_PER_VIEW = 4;

export const MIN_SWIPER_CHANGES = SIDE_SWIPER_SLIDES_PER_VIEW;

export const POPUP_NEXT_INTERVAL = 20000;
export const POPUP_NEXT_DURATION = 5000;
